import React from 'react';
import ReportRequestManager from './ReportRequestManager.jsx';
import { ReportTypeStep, ContentTypeStep, ReviewStep } from './steps';

export const ReportRequestGenerator = ({ close }) => (
  <ReportRequestManager close={close}>
    <ReportTypeStep />
    <ContentTypeStep />
    <ReviewStep />
  </ReportRequestManager>
);

export default ReportRequestGenerator;
